module.exports = __webpack_public_path__ + "static/media/company-address-hide.02ad6888.png";